import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am{" "}
            <span className="purple">I. Divya Teja</span>{" "}
            from <span className="purple">Hyderabad, India.</span>
            <br />
            <br />
            I am pursuing my B.E. in Computer Science at CBIT, with a passion
            for <span className="purple">Full-Stack Development</span>,{" "}
            <span className="purple">Machine Learning</span>, and{" "}
            <span className="purple">Cybersecurity</span>.
            <br />
            <br />
            Beyond coding, here are a few things I enjoy:
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Chess
            </li>
            <li className="about-activity">
              <ImPointRight /> Exploring New Technologies & Hackathons
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>
          
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
